import React from 'react';

import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import { CommissionsCalculationMethodInput } from 'shared/widgets/CommissionsCalculationMethodInput/CommissionsCalculationMethodInput';
import { useLadderCalculationMethodVisibility } from 'shared/widgets/CommissionsCalculationMethodInput/hooks/useLadderCalculationMethodVisibility';
import { useResetCalculationMethodOnHide } from 'shared/widgets/CommissionsCalculationMethodInput/hooks/useResetCalculationMethodOnHide';

export const CommissionsCreateLadderCalculationMethod = () => {
  const isVisible = useLadderCalculationMethodVisibility();
  useResetCalculationMethodOnHide(isVisible);

  if (!isVisible) {
    return null;
  }

  return (
    <Box>
      <Typography fontWeight={500} sx={{ mb: 2 }} variant="body1">
        Способ расчёта
      </Typography>
      <CommissionsCalculationMethodInput />
    </Box>
  );
};
